export default "__VITE_PUBLIC_ASSET__3b05a0bd__"